'use es6';

import keyMirror from 'react-utils/keyMirror';
export default Object.freeze(keyMirror({
  MARKETING_IMAGE_SMALL: null,
  SCREENSHOT: null,
  // NOTE: These are temporary until images are returned as arrays
  MODULE_IMAGE_1: null,
  MODULE_IMAGE_2: null,
  MODULE_IMAGE_3: null,
  MODULE_IMAGE_4: null,
  MODULE_IMAGE_5: null
}));